import React from 'react'
import { useDispatch } from 'react-redux';

import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import domain_list from '../../Data/domain_list';
import useLanguage from '../common_hooks/useLanguage';
import { block_license_with_handler } from '../../App/actions/filter_license';

function BLOCKED(params) {
  const { dict, language } = useLanguage();
  const history = useHistory();
  const location = useLocation();

  const setQuery = (body) => {
    const params = new URLSearchParams(body);
    history.push({
      pathname: location.pathname, search: params.toString()
    })
  }

  const domain_w_port = window.location.host;
  const is_login_kai = domain_list[domain_w_port]?.is_domain_kai || false;

  const { license_basic, license_sini_ai, license_sini_data } = params || {};
  const arr = []
  if (license_basic) arr.push("Basic")
  if (license_sini_ai) arr.push("SINI AI")
  if (license_sini_data) arr.push("SINI DATA")

  const dispatch = useDispatch();

  const handle_buy = () => {
    handleFilterChange()
    dispatch(block_license_with_handler("ketengan"));
  }

  const handleFilterChange = () => {
    let body = { month: 1, payment_type: "personal", is_partial: true }
    if (license_sini_data) body.license = "license_sini_data"
    else if (license_sini_ai) body.license = "license_sini_ai"
    else if (license_basic) body.license = "license_sini_basic"
    setQuery(body)
  };

  let note = `Get ${arr.join(" + ")}`
  let button_text = dict["Buy"][language]
  if (is_login_kai) {
    note = dict["No license"][language];
    button_text = "Detail"
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px", margin: "5px" }}>
      <label style={{ textAlign: "center" }}>{note}</label>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <button onClick={handle_buy} className='button_big background_black' style={{ width: "100px" }}>
          {button_text}
        </button>
      </div>
    </div>
  )
}

export default BLOCKED